import "./App.css";
import Header from "./components/Header";
// import Hero from "./sections/Hero";

function App() {
  return (
    <div className="App">
      <Header />
      {/* <Hero /> */}
    </div>
  );
}

export default App;
